'use client';

import { FC } from 'react';
import Icon from '~/components/icon';

import { useCity } from '../context';
import styles from './styles.module.css';

interface Props {
  active: boolean;
  onToggle: () => void;
}

const CityMobileBar: FC<Props> = ({ active, onToggle }) => {
  const { selectedCity, address } = useCity();

  return (
    <button
      type="button"
      className={styles.bar}
      onClick={onToggle}
      aria-label={active ? 'Назад в меню' : 'Выбрать город'}
    >
      {active ? (
        <>
          <Icon name="chevron" className={styles.backIcon} />
          <span>Выберите город</span>
        </>
      ) : (
        <>
          <Icon name="location-marker" className={styles.markerIcon} />
          <span>
            {selectedCity.title}
            {address && <span className={styles.address}>, {address}</span>}
          </span>
          <Icon name="chevron" className={styles.chevronIcon} />
        </>
      )}
    </button>
  );
};

export default CityMobileBar;
